export const campaignConstants = {
  CAMPAIGN_REQUEST: 'CAMPAIGN_REQUEST',
  CAMPAIGN_SUCCESS: 'CAMPAIGN_SUCCESS',
  CAMPAIGN_FAILURE: 'CAMPAIGN_FAILURE'
}
